import { shell } from './shellClasses';

export function StatusFooter() {
  return (
    <footer className={`${shell.footer} px-4 py-3 text-center text-xs lg:px-8`}>
      Founder OS
    </footer>
  );
}
